import script from "./AtomRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomRadio.vue?vue&type=script&lang=ts&setup=true"

import "./AtomRadio.vue?vue&type=style&index=0&id=8a16822e&lang=css"

const __exports__ = script;

export default __exports__